import { render, staticRenderFns } from "./EmailDistribution.vue?vue&type=template&id=50247c88&"
import script from "./EmailDistribution.vue?vue&type=script&lang=ts&"
export * from "./EmailDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports